import React, { useState } from "react";
import {
  Table,
  Form,
  Dropdown,
  Button,
  Modal,
} from "react-bootstrap";

import {
  FiDownload,
  FiFileText,
  FiTrash2,
  FiChevronDown,
} from "react-icons/fi";
import CandidatesHeader from "../../components/administration/Candidates/CandidatesHeader";



const data = [
    {
    id: "Cand-001",
    name: "Harold Gaynor",
    role: "Accountant",
    phone: "(146) 8964 278",
    date: "12 Sep 2024",
    status: "Sent",
    img: "/assets/img/users/user-01-1.jpg",
  },
  {
    id: "Cand-002",
    name: "Sandra Ornellas",
    role: "App Developer",
    phone: "(148) 9648 218",
    date: "24 Oct 2024",
    status: "Scheduled",
    img: "/assets/img/users/user-34.jpg",
  },
  {
    id: "Cand-003",
    name: "John Harris",
    role: "Technician",
    phone: "(196) 2348 947",
    date: "18 Feb 2024",
    status: "Interviewed",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    id: "Cand-004",
    name: "Carole Langan",
    role: "Web Developer",
    phone: "(138) 6487 295",
    date: "17 Oct 2024",
    status: "Offered",
    img: "/assets/img/users/user-26.jpg",
  },
  {
    id: "Cand-005",
    name: "Charles Marks",
    role: "Sales Executive Officer",
    phone: "(154) 6485 218",
    date: "20 Jul 2024",
    status: "Hired",
    img: "/assets/img/users/user-39.jpg",
  },
  {
    id: "Cand-006",
    name: "Kerry Drake",
    role: "Designer",
    phone: "(185) 5947 097",
    date: "20 Jul 2024",
    status: "Rejected",
    img: "/assets/img/users/user-24.jpg",
  },
  {
    id: "Cand-007",
    name: "David Carmona",
    role: "Account Manager",
    phone: "(106) 3485 978",
    date: "29 Aug 2024",
    status: "Hired",
    img: "/assets/img/users/user-33-1.jpg",
  },
];

const CandidatesList = () => {
  const [showDelete, setShowDelete] = useState(false);
const [search, setSearch] = useState("");
const [rowsPerPage, setRowsPerPage] = useState(10);
 const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("03/27/2026 - 04/02/2026");

   const options = [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "This Year",
    "Next Year",
    "Custom Range",
  ];

  const handleSelect = (item) => {
    setSelected(item);
    setOpen(false);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Sent":
        return "badge-purple";
      case "Scheduled":
        return "badge-pink";
      case "Interviewed":
        return "badge-info";
      case "Offered":
        return "badge-warning";
      case "Hired":
        return "badge-success";
      case "Rejected":
        return "badge-danger";
      default:
        return "";
    }
  };

  
  return (
    <div className="container-fluid p-3">
<CandidatesHeader/>
      {/* HEADER */}
      <div className="card mb-3">
        <div style={{backgroundColor:" #ffffff"}} className="card-header d-flex justify-content-between flex-wrap">

          <h5>Candidates List</h5>

          <div className="d-flex gap-2 flex-wrap">

            {/* DATE */}
       <div className="date-dropdown-wrapper">

      {/* INPUT BOX */}
      <div
        className="input-box"
        onClick={() => setOpen(!open)}
      >
        <input value={selected} readOnly />
        <FiChevronDown />
      </div>

      {/* DROPDOWN */}
      {open && (
        <div className="date-dropdown-menu">
          {options.map((item, i) => (
            <div
              key={i}
              className={`dropdown-item-custom ${
                item === selected ? "active" : ""
              }`}
              onClick={() => handleSelect(item)}
            >
              {item}
            </div>
          ))}
        </div>
      )}
    </div>

            {/* ROLE */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white">
                Role
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Accountant</Dropdown.Item>
                <Dropdown.Item>Technician</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* STATUS */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white">
                Select Status
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Scheduled</Dropdown.Item>
                <Dropdown.Item>Interviewed</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* SORT */}
            <Dropdown>
              <Dropdown.Toggle className="btn-white">
                Sort By : Last 7 Days
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item>Ascending</Dropdown.Item>
                <Dropdown.Item>Descending</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

          </div>
        </div>
        <div className="card-header d-flex justify-content-between align-items-center flex-wrap">

  {/* LEFT */}
  <div className="d-flex align-items-center gap-2 mb-2">
    <span>Row Per Page</span>

    <Form.Select
      value={rowsPerPage}
      onChange={(e) => setRowsPerPage(e.target.value)}
      className="rows-select"
    >
      <option value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
    </Form.Select>

    <span>Entries</span>
  </div>

  {/* RIGHT SEARCH */}
  <div className="mb-2">
    <input
      type="text"
      placeholder="Search"
      className="search-box"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>

</div>

        {/* TABLE */}
        <div className="card-body p-0">
          <div className="table-responsive">
            <Table className="mb-0">
              <thead>
                <tr>
                  <th>
                    <Form.Check />
                  </th>
                  <th>Cand ID</th>
                  <th>Candidate</th>
                  <th>Applied Role</th>
                  <th>Phone</th>
                  <th>Applied Date</th>
                  <th>Resume</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
               
                {data
  .filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) ||
    item.role.toLowerCase().includes(search.toLowerCase()) ||
    item.id.toLowerCase().includes(search.toLowerCase())
  )
  .slice(0, rowsPerPage).map((item, i) => (
                  <tr key={i}>
                    <td><Form.Check /></td>

                    <td>{item.id}</td>

                    <td>
                      <div className="d-flex align-items-center">
                        <img src={item.img} className="avatar" />
                        <div className="ms-2">
                          <h6>{item.name}</h6>
                          <span>[email protected]</span>
                        </div>
                      </div>
                    </td>

                    <td>{item.role}</td>
                    <td>{item.phone}</td>
                    <td>{item.date}</td>

                    <td>
                      <FiFileText className="me-2" />
                      <FiDownload />
                    </td>

                    <td>
                      <span className={`badge-custom ${getStatusClass(item.status)}`}>
                        ● {item.status}
                      </span>
                    </td>

                    <td>
                      <FiTrash2
                        className="delete-icon"
                        onClick={() => setShowDelete(true)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>

      {/* DELETE MODAL */}
      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered>
        <Modal.Body className="text-center p-4">

          <div className="delete-box">
            <FiTrash2 size={26} />
          </div>

          <h4>Confirm Delete</h4>
          <p>
            You want to delete all the marked items, this cant be undone once you delete.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <Button className="btn-light" onClick={() => setShowDelete(false)}>
              Cancel
            </Button>
            <Button className="btn-danger">Yes, Delete</Button>
          </div>

        </Modal.Body>
      </Modal>
<style>
     {
          `
          .card {
 
border-radius:5px;
border:2px solid #e5e7eb;
  background: #ffffff !important;

}

/* INPUT */
.input-box {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
}

.input-box input {
  border: none;
  outline: none;
  font-size: 14px;
}

/* BUTTON */
.btn-white {
  background: #fff !important;
  border: 1px solid #ddd !important;
  color: #333 !important;
}

/* AVATAR */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* BADGES */
.badge-custom {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
}

.badge-purple {
  border: 1px solid purple;
  color: purple;
}

.badge-pink {
  border: 1px solid hotpink;
  color: hotpink;
}

.badge-info {
  border: 1px solid #0dcaf0;
  color: #0dcaf0;
}

.badge-warning {
  border: 1px solid orange;
  color: orange;
}

.badge-success {
  border: 1px solid green;
  color: green;
}

.badge-danger {
  border: 1px solid red;
  color: red;
}

/* DELETE ICON */
.delete-icon {
  cursor: pointer;
  color: #6c757d;
}

/* MODAL */
.delete-box {
  width: 70px;
  height: 70px;
  background: #ffe5e5;
  color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin: 0 auto 15px;
}
/* ROW SELECT */
.rows-select {
  width: 70px;
  height: 34px;
  font-size: 14px;
  border-radius: 6px;
}

/* SEARCH */
.search-box {
  border: 1px solid #ddd;
  padding: 6px 12px;
  border-radius: 6px;
  width: 200px;
  font-size: 14px;
}


/* RESPONSIVE */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .search-box {
    width: 100%;
  }
}

// dates
/* WRAPPER */
.date-dropdown-wrapper {
  position: relative;
  width: auto;
}

/* INPUT BOX */
.input-box {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  cursor: pointer;
}

.input-box input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 14px;
  cursor: pointer;
}

/* DROPDOWN */
.date-dropdown-menu {
  position: absolute;
  top: 45px;
  width: 15%;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  z-index: 999;
  overflow: hidden;
}

/* ITEM */
.dropdown-item-custom {
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

/* HOVER */
.dropdown-item-custom:hover {
  background: #ef8019;
}

/* ACTIVE (ORANGE LIKE IMAGE) */
.dropdown-item-custom.active {
  background: #ff6b1a;
  color: #fff;
}

/* SMALL ARROW (OPTIONAL) */
.date-dropdown-menu::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 20px;
  width: 10px;
  height: 10px;
  background: white;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  transform: rotate(45deg);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    gap: 10px;
  }
}`
     }
</style>
    </div>
  );
};

export default CandidatesList;